import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import NotificationBell from './NotificationBell'
import './Navbar.css'

export default function Navbar() {
  const { user, profile, signOut } = useAuth()
  const navigate = useNavigate()
  const [menuOpen, setMenuOpen] = useState(false)

  async function handleSignOut() {
    await signOut()
    navigate('/')
  }

  const displayName = profile?.display_name || profile?.full_name || ''

  return (
    <nav className="navbar">
      <div className="navbar-inner container">
        <Link to={user ? "/dashboard" : "/"} className="navbar-logo">
          <span className="logo-mark">H</span>
          <span className="logo-text">humanorigin</span>
        </Link>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <Link to="/wall" onClick={() => setMenuOpen(false)}>Wall</Link>
          <Link to="/browse" onClick={() => setMenuOpen(false)}>Browse</Link>
          <Link to="/faq" onClick={() => setMenuOpen(false)}>FAQ</Link>
          {user ? (
            <>
              <Link to="/review" onClick={() => setMenuOpen(false)}>Review</Link>
              {profile?.username && (
                <Link to={`/u/${profile.username}`} onClick={() => setMenuOpen(false)}>My Profile</Link>
              )}
              {profile?.is_admin && <Link to="/admin" onClick={() => setMenuOpen(false)}>Admin</Link>}
              <NotificationBell />
              <Link to="/settings/profile" onClick={() => setMenuOpen(false)} className="navbar-avatar-btn">
                {profile?.avatar_url
                  ? <img src={profile.avatar_url} alt={displayName} className="navbar-avatar-img" />
                  : <div className="navbar-avatar-placeholder">{displayName ? displayName.charAt(0).toUpperCase() : '?'}</div>
                }
              </Link>
              <Link to="/dashboard" className="btn btn-primary btn-sm navbar-dashboard-btn" onClick={() => setMenuOpen(false)}>Dashboard</Link>
              <button className="btn btn-secondary btn-sm" onClick={handleSignOut}>Sign out</button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn btn-secondary btn-sm" onClick={() => setMenuOpen(false)}>Sign in</Link>
              <Link to="/login" className="btn btn-primary btn-sm" onClick={() => setMenuOpen(false)}>Get verified</Link>
            </>
          )}
        </div>

        <button className="navbar-burger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </div>
    </nav>
  )
}
